export const FIRST_LETTER_ALPHANUMERIC = /^[\p{L}\p{M}\p{N}]/gu;
export const PHONE_NUMBER_VALIDATION = /^\+?\d{7,}$/;
export const PHONE_NUMBER_INPUT_VALIDATION = /^\+?\d*$/;
